var exports = {
  "kL": "xa15a2ab7--f6ae9b--container",
  "nV": "xa15a2ab7--f6ae9b--gallery",
  "_8": "xa15a2ab7--f6ae9b--img",
  "hJ": "xa15a2ab7--f6ae9b--counter",
  "h_": "xa15a2ab7--f6ae9b--description",
  "DD": "xa15a2ab7--f6ae9b--title",
  "RF": "xa15a2ab7--f6ae9b--more-button",
};

module.exports = exports;
